import { PaidNewsletterErrorNames, PaidNewsletterErrors } from "@/store/paidNewsletterCreator/types";
import { NewsletterPayload } from "@dev/ee-api/ee-api-models";
import { isProductPriceValid } from "./isProductPriceValid";

const isErrorIncluded = (conditionErrorName: PaidNewsletterErrorNames, errorNames?: PaidNewsletterErrorNames[]): boolean => 
    !errorNames?.length || !!errorNames?.includes(conditionErrorName);

export const getPaidNewsletterErrors = (paidNewsletterPayload: NewsletterPayload, errorNames?: PaidNewsletterErrorNames[]): PaidNewsletterErrors => {
    const errors: PaidNewsletterErrors = {}
    if (isErrorIncluded(PaidNewsletterErrorNames.INVALID_PRODUCT_PRICE, errorNames) && paidNewsletterPayload?.ProductPrice >=0 && !isProductPriceValid(paidNewsletterPayload?.ProductPrice,paidNewsletterPayload?.Currency)) {
        errors[PaidNewsletterErrorNames.INVALID_PRODUCT_PRICE] = true;
    }
    return errors;
}
